// extracted by mini-css-extract-plugin
export default {"landBg":"pages_landBg__hIs3+","cover":"pages_cover__CF9+a","mcover":"pages_mcover__772KQ","but1":"pages_but1__dxyti","but2":"pages_but2__PeVdo","land2":"pages_land2__Hgkj7"};